// extracted by mini-css-extract-plugin
export default {"location-form":"LocationForm_location-form__gjPGB"};